<div *ngIf="view" class="custom-control custom-checkbox col">
  <input type="checkbox" #chekboxButton [checked]="view.value" (click)="onClick($event)" class="custom-control-input" id="{{view.id}}">
  <label class="custom-control-label" for="{{view.id}}">{{view.title}}</label>
</div>